import $store from '@/store/index'
import SlimApi from '@/util/slimapi'
import Data from '@/util/data'
import Util from '@/util/util'

export default {
  getHooks () {
    Data.vm.$Notice.config({
      top: 80
    })

    SlimApi.get(`hook/list?token=${$store.state.sys.token}`).then(response => {
      if (response.data.err) {
        Data.vm.$Notice.error({
          title: Data.vm.$text.tr('Ошибка'),
          desc: Util.returnTextForErr(response.data.err)
        })
        return
      }

      $store.state.hooks.hookList = response.data.data
    }).catch(error => {
      Data.vm.$Notice.error({
        title: Data.vm.$text.tr('Ошибка'),
        desc: Util.returnTextForErr(error)
      })
    })
  },
  editHook (params = {}, index) {
    return SlimApi.post(`hook/edit?token=${$store.state.sys.token}`, params)
      .then((response) => {
        if (response.data.err) {
          Data.vm.$Notice.error({
            title: Data.vm.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(response.data.err)
          })
          return
        }

        if (params.Id) {
          this.EDIT_HOOK(response.data.data, index)
        } else {
          this.ADD_HOOK(response.data.data, params)
        }
      }).catch(error => {
        Data.vm.$Notice.error({
          title: Data.vm.$text.tr('Ошибка'),
          error
        })
      })
  },
  removeHook (hid) {
    SlimApi.get(`hook/del?token=${$store.state.sys.token}`, {
      params: {
        hid
      }
    }).then((response) => {
      if (response.data.err) {
        Data.vm.$Notice.error({
          title: Data.vm.$text.tr('Ошибка'),
          desc: Util.returnTextForErr(response.data.err)
        })
        return
      }

      this.DELETE_HOOK()
    }).catch(error => {
      Data.vm.$Notice.error({
        title: Data.vm.$text.tr('Ошибка'),
        desc: Util.returnTextForErr(error)
      })
    })
  },
  sendTicker (params) {
    SlimApi.post(`hook/test?token=${$store.state.sys.token}`, params).then(response => {
      if (response.data.err) {
        Data.vm.$Notice.error({
          title: Data.vm.$text.tr('Ошибка'),
          desc: Util.returnTextForErr(response.data.err)
        })
        return
      }

      Data.vm.$Notice.success({
        title: Data.vm.$text.tr('Успешно')
      })
    }).catch(error => {
      Data.vm.$Notice.error({
        title: Data.vm.$text.tr('Ошибка'),
        desc: Util.returnTextForErr(error)
      })
    })
  },
  DELETE_HOOK () {
    $store.state.hooks.hookList.splice($store.state.hooks.currentHookIndex, 1)
    $store.state.hooks.currentHookIndex = 0

    Data.vm.$Notice.success({
      title: Data.vm.$text.tr('Хук удален')
    })
  },
  ADD_HOOK (hook, params) {
    $store.state.hooks.hookList.unshift(hook)
    $store.state.hooks.currentHookIndex = 0

    if (params.Name) {
      Data.vm.$Notice.success({
        title: Data.vm.$text.tr('Хук продублирован')
      })
    } else {
      Data.vm.$Notice.success({
        title: Data.vm.$text.tr('Новый хук добавлен')
      })
    }
  },
  EDIT_HOOK (hook) {
    $store.state.hooks.isEditingHook = false
    $store.state.hooks.cashedCurrentHook = JSON.parse(JSON.stringify(hook))

    Data.vm.$Notice.success({
      title: Data.vm.$text.tr('Изменения сохранены')
    })
  }
}
